import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { legacy_createStore as createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';

import sessionReducer from './store/reducers/sessionReducer';
import cartReducer from './store/reducers/cartReducer';
import catalogReducer from './store/reducers/catalogReducer';
import filterReducer from './store/reducers/filterReducer';
import customerReducer from './store/reducers/customerReducer';



const sessionPersistConfig = {
    key: 'session',
    storage,
};

const customerPersistConfig = {
    key: 'customer',
    storage,
    whitelist: [
        'customer',
        'customerMembership',
        'last_order',
        'active_table_orders',
    ],
};

const cartPersistConfig = {
    key: 'cart',
    storage,
    whitelist: [
        'addedItems',
        'subTotal',
        'total',
        'tip',
        'orderType',
        'appliedOffer',
        'selectedTender',
        'orderPlace',
        'total_tax',
        'resultDis',
        'child_store_id',
        'offline_invoice_no',
        'engineDiscount',
    ],
};

const filterPersistConfig = {
    key: 'filter',
    storage,
};

const catalogPersistConfig = {
    key: 'catalog',
    storage,
};

const rootReducer = combineReducers({
    sessionReducer: persistReducer(sessionPersistConfig, sessionReducer),
    cartReducer: persistReducer(cartPersistConfig, cartReducer),
    catalogReducer: persistReducer(catalogPersistConfig, catalogReducer),
    filterReducer: persistReducer(filterPersistConfig, filterReducer),
    customerReducer: persistReducer(customerPersistConfig, customerReducer),
});

export const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);
const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>
);

reportWebVitals();
